import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import { ICustomerName } from "../models/ICustomer";
import { storeImpersonation } from "../utils/impersonation";

/** SAV only: switch the whole dashboard to act as another customer, or back to SAV. */
export default function useImpersonation() {
  const { isSavUser, impersonating, dispatchAuthEvent } = useAuth();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const switchTo = async (customer: ICustomerName | null) => {
    if (!isSavUser) return;

    // Store first: the API helper reads it per request, so anything refetched below goes out as the new customer
    storeImpersonation(customer);
    await queryClient.cancelQueries();
    dispatchAuthEvent({ type: "impersonate", payload: customer });

    // The page we're on may be a lead/quote that belongs to the previous customer
    navigate("/");

    // Everything cached was fetched as the previous customer. The SAV-only customer list is the exception.
    queryClient.resetQueries({ predicate: (q) => q.queryKey[0] !== "customers" });
  };

  return {
    isSavUser,
    impersonating,
    impersonate: (customer: ICustomerName) => switchTo(customer),
    stopImpersonating: () => switchTo(null),
  };
}
